import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

export function TableHeader({ selectedRow }) {
  return (
    <Vertical
      className='p-4'
      borderRadius='6px 6px 0px 0px'
      style={{
        backgroundColor: 'var(--theme-color-1)',
        width: '100%',
        maxHeight: '160px',
        minHeight: '160px',
      }}
    >
      <Vertical flex={1} className='mb-4'>
        <Texto appearance='white' align='left'>
          Viewing Pay Mileage Bands For:
        </Texto>
        <Texto appearance='white' align='left' category='h4' className='full-height-width text-truncate'>
          {selectedRow?.name}
        </Texto>
      </Vertical>
      <Horizontal className='mb-0' flex={1} alignItems='flex-end' style={{ maxHeight: '50px' }}>
        <Vertical justifyContent='end'>
          <Texto appearance='white' align='left'>
            Product Group
          </Texto>
          <Texto appearance='white' category='h6' className='full-height-width text-truncate'>
            {!selectedRow ? '' : selectedRow?.product_group || 'All Product Groups'}
          </Texto>
        </Vertical>
        <Vertical justifyContent='end'>
          <Texto appearance='white' align='left'>
            Unit
          </Texto>
          <Texto appearance='white' category='h6' className='full-height-width text-truncate'>
            {selectedRow?.unit}
          </Texto>
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
